import { request } from './config/utils'

import { Params } from '../../constants'

export function customerServiceCentersPostRequest(params) {

    return request('post', params, Params.CUSTOMER_SERVICE_CENTERS_POST)
}